import { Component, type ErrorInfo, type ReactNode } from 'react';

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

// Catches render exceptions in the routed page content (including a failed
// lazy-chunk fetch) so a bug in one page shows a recoverable message instead
// of white-screening the whole app. Must be a class component — React has no
// hook-based equivalent to componentDidCatch/getDerivedStateFromError.
export default class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Unhandled error in page content:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="page-error">
          <p>Something went wrong loading this page.</p>
          <button type="button" className="btn btn-secondary" onClick={() => window.location.reload()}>
            Reload
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
